import { Component, ChangeDetectionStrategy, Input, OnInit, OnDestroy } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, of } from 'rxjs';

import { CampaignBannerService } from '@fcom/common/services/campaign-banner/campaign-banner.service';
import { AspectRatios } from '@fcom/ui-components';
import { CmsArticle, CmsMedia } from '@fcom/core-api';

@Component({
  selector: 'fin-destination-search-hero',
  templateUrl: 'destination-search-hero.component.html',
  styleUrls: ['destination-search-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DestinationSearchHeroComponent implements OnInit, OnDestroy {
  aspectRatio$: Observable<keyof typeof AspectRatios> = of('21x9');
  picture: CmsMedia;
  campaignText: string;
  iconName: SvgLibraryIcon;
  enableBlackTeaser: boolean;

  @Input()
  content: CmsArticle;

  constructor(private campaignBannerService: CampaignBannerService) {}

  ngOnInit(): void {
    this.picture = this.content.media?.[0] ?? null;
    this.campaignText = this.content.related?.[0]?.teaserText ?? null;
    this.iconName = this.content.related?.[0]?.localSettings?.iconName ?? SvgLibraryIcon.AIRCRAFT_TILTED;
    this.enableBlackTeaser = !!this.content.related?.[0]?.localSettings?.enableBlackTeaser;

    if (this.campaignText) {
      this.campaignBannerService.setCampaignBannerVisibility(false);
    }
  }

  ngOnDestroy(): void {
    this.campaignBannerService.setCampaignBannerVisibility(true);
  }
}
